import { render } from "./TransitionExpand.vue?vue&type=template&id=90f2a466&scoped=true"
import script from "./TransitionExpand.vue?vue&type=script&lang=js"
export * from "./TransitionExpand.vue?vue&type=script&lang=js"

import "./TransitionExpand.vue?vue&type=style&index=0&id=90f2a466&scoped=true&lang=css"

import exportComponent from "/Users/johan/dev/litteraturkartan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90f2a466"]])

export default __exports__